import React from 'react';
import TrophySolid from '@assets/icons/trophy-solid';
import { CDN_URL } from '@utils/constants/url.constants';
import ArrowDown from '@assets/icons/arrow-down';
import ArrowUp from '@assets/icons/arrow-up';
import { Avatar } from 'geniebook-ui/dist';

export interface LeaderboardTableItemProps {
  standing: number;
  profilePicture: string;
  name: string;
  bubble: number;
  lastStanding?: number | null;
  isCurrentUser?: boolean;
  student_id: number;
}

const LeaderboardTableItem = (props: LeaderboardTableItemProps) => {
  function trophyColorClass(standing: number) {
    switch (standing) {
      case 1:
        return 'text-[#FED00B]';
      case 2:
        return 'text-[#C3CAD6]';
      default:
        return 'text-[#F6C483]';
    }
  }

  return (
    <div
      className={
        'flex items-center font-bold text-neutral-whiteboard mb-2 last:mb-0 py-1 md:px-6 max-md:px-4 rounded-2xl ' +
        (props.isCurrentUser ? 'bg-primary-navyblue-bright/[0.65]' : '')
      }
    >
      <div className={'w-7 text-xs leading-3 md:mr-8 max-md:mr-2 shrink-0'}>
        {props.standing <= 3 ? (
          <TrophySolid
            className={
              'fill-current scale-150 ' + trophyColorClass(props.standing)
            }
          />
        ) : (
          props.standing
        )}
      </div>
      <div className={'mr-4 shrink-0'}>
        <Avatar
          size={40}
          alt={props.name}
          src={props.profilePicture}
          studentId={props.student_id}
        />
      </div>
      <div className={'flex-grow truncate leading-5 mr-auto'}>{props.name}</div>
      {props.lastStanding && props.lastStanding !== props.standing ? (
        <div className={'leading-3 text-xs min-w-[32px] md:mr-16'}>
          {props.lastStanding > props.standing ? (
            <ArrowUp
              className={'fill-current text-[#72CC7C] mr-1 inline w-3'}
            />
          ) : (
            <ArrowDown
              className={'fill-current text-[#EF4A46] mr-1 inline w-3'}
            />
          )}
          {Math.abs(props.lastStanding - props.standing)}
          <span className={'max-lg:hidden'}>
            {Math.abs(props.lastStanding - props.standing) === 1
              ? ' place'
              : ' places'}
          </span>
        </div>
      ) : null}
      <div
        className={
          'ml-4 md:text-sm max-md:text-xs md:leading-3.5 max-md:leading-3 w-[60px] shrink-0'
        }
      >
        <img
          src={`${CDN_URL}assets/icons/general/bubble.svg`}
          alt={'bubble'}
          className={'w-5 h-5 mr-1 inline'}
        />
        <span>{props.bubble ?? 0}</span>
      </div>
    </div>
  );
};

export default LeaderboardTableItem;
